import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { Image } from 'react-bootstrap';

const ImagesScreen = ({ src, className, ...rest }) => {
 const [isOpen, setIsOpen] = useState(false);
 return (
  <>
   <Image {...rest} src={src} className={'cursor-pointer ' + className ?? ''} onClick={() => setIsOpen(true)} />
   {isOpen && (
    <Lightbox
     mainSrc={src}
     onCloseRequest={() => setIsOpen(false)}
     reactModalStyle={{ overlay: { zIndex: 999999 } }}
     onImageLoad={() => {
      window.dispatchEvent(new Event('resize'));
     }}
    />
   )}
  </>
 );
};
ImagesScreen.propTypes = { ...Image.propTypes };
export default ImagesScreen;
